(function () {
  'use strict';
  if (window.__timbaClarityConsent) return;
  window.__timbaClarityConsent = true;
  var requested = false;
  var stopped = false;
  var ready = false;
  var privacy;
  function choices() {
    var consent = privacy.currentVisitorConsent();
    return {
      analytics: consent.analytics === 'yes' && privacy.analyticsProcessingAllowed(),
      marketing: consent.marketing === 'yes' && privacy.marketingAllowed()
    };
  }
  function signal(state) {
    window.clarity('consentv2', {
      analytics_Storage: state.analytics ? 'granted' : 'denied',
      ad_Storage: state.marketing ? 'granted' : 'denied'
    });
  }
  function sync() {
    if (!ready) return;
    var state;
    try { state = choices(); } catch (_) { state = { analytics: false, marketing: false }; }
    if (!state.analytics) {
      if (requested && !stopped) {
        signal({ analytics: false, marketing: false });
        window.clarity('stop');
        stopped = true;
      }
      return;
    }
    if (stopped) {
      window.location.reload();
      return;
    }
    if (requested) { signal(state); return; }
    requested = true;
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    signal(state);
    var script = document.createElement('script');
    script.async = true;
    script.id = 'timba-clarity-consented';
    script.src = 'https://www.clarity.ms/tag/ytgrqzzx52';
    script.onload = function () {
      if (stopped) { signal({ analytics: false, marketing: false }); window.clarity('stop'); }
      else sync();
    };
    script.onerror = function () { stopped = true; };
    document.head.appendChild(script);
  }
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pageshow', sync);
  function initialise() {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error || !window.Shopify.customerPrivacy) return;
      privacy = window.Shopify.customerPrivacy;
      ready = true;
      sync();
    });
  }
  initialise();
})();
